import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
import UnreadNotificationsCount from '@/components/v2/UnreadNotificationsCount';
import LogoutMixin from '@/helpers/mixins/LogoutMixin';
import FormatNotificationCountMixin from '@/helpers/vue_mixins/FormatNotificationCountMixin';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
const opts = { namespace: NAV_DRAWER };
let MobileUserSettings = class MobileUserSettings extends Mixins(LogoutMixin, FormatNotificationCountMixin, RouterPathMixin, ViewportSizeMixin, AffiliateMixin) {
    /* Temporary set to method for future development */
    userSettings() {
        return [
            {
                text: 'My In-App Stores',
                exact: false,
                click: this.goToAppsDashboard,
                hidden: false,
            },
            {
                text: 'Notifications',
                exact: false,
                click: this.showNotificationsList,
                hidden: this.isHidden(),
            },
            {
                text: 'Sales Partner Manager',
                exact: false,
                click: this.redirectToAffiliate,
                hidden: this.isClient(),
            },
            {
                text: 'My Account',
                key: 'profile',
                icon: '',
                click: this.redirectToUserProfile,
                hidden: false,
            },
            {
                text: 'Logout',
                exact: false,
                click: this.logoutAccount,
                hidden: false,
            },
        ];
    }
    logoutAccount() {
        // const token = sessionStorage.getItem(AUTH_TOKEN);
        // Temporary fix for login issue
        // this.destroyToken(token);
        this.$store.commit('resetAppState', '');
        this.logout();
    }
    onToggle(val) {
        if (!val) {
            this.hideUserSettings();
        }
    }
    isHidden() {
        return !this.appUuid || this.isAppsPath() || this.isDiy();
    }
    showNotificationsList() {
        this.showNotifications();
        this.hideUserSettings();
    }
    goToAppsDashboard() {
        this.$router.push('/apps');
        this.closeDrawer();
    }
    redirectToAffiliate() {
        this.closeDrawer();
        this.goToAffiliate(this.setCurrentUser.uuid);
    }
    redirectToUserProfile() {
        this.$router.push('/profile');
    }
    isClient() {
        if (this.setCurrentUser.affiliateCode && this.setCurrentUser.role === 'reseller') {
            return false;
        }
        return true;
    }
};
__decorate([
    Getter('appUuid')
], MobileUserSettings.prototype, "appUuid", void 0);
__decorate([
    Getter('showUserSettings', opts)
], MobileUserSettings.prototype, "showUserSettings", void 0);
__decorate([
    Getter('setCurrentUser', opts)
], MobileUserSettings.prototype, "setCurrentUser", void 0);
__decorate([
    Mutation('hideUserSettings', opts)
], MobileUserSettings.prototype, "hideUserSettings", void 0);
__decorate([
    Mutation('showNotifications', opts)
], MobileUserSettings.prototype, "showNotifications", void 0);
MobileUserSettings = __decorate([
    Component({
        components: {
            UnreadNotificationsCount,
        },
    })
], MobileUserSettings);
export default MobileUserSettings;
